import { useCallback, useRef, useState } from 'react';
import { create } from "./logger";
const logger = create('sse-client');
export function connectSSE(config, handlers) {
    const { url, withCredentials = false } = config;
    const eventSource = new EventSource(url, { withCredentials });
    eventSource.onmessage = (event) => {
        try {
            const parsed = JSON.parse(event.data);
            const items = Array.isArray(parsed) ? parsed : [parsed];
            const sseEvents = items.map(item => ({
                type: event.type || 'message',
                data: item,
                id: event.lastEventId || undefined,
            }));
            handlers.onEvent(sseEvents);
        }
        catch {
            logger.warn('Failed to parse SSE data – skipping event:', event.data);
        }
    };
    eventSource.onerror = () => {
        if (eventSource.readyState === EventSource.CLOSED) {
            const error = {
                code: 'CONNECTION_CLOSED',
                message: 'SSE connection closed unexpectedly.',
            };
            logger.error('SSE connection closed:', error.message);
            handlers.onError?.(error);
            handlers.onComplete?.();
        }
        else {
            logger.log('SSE connection interrupted – auto-reconnecting…');
        }
    };
    eventSource.onopen = () => {
        logger.log('SSE connection established.');
    };
    return () => {
        eventSource.close();
        logger.log('SSE connection closed by client.');
        handlers.onComplete?.();
    };
}
export function useSSEStream() {
    const [isStreaming, setIsStreaming] = useState(false);
    const cleanupRef = useRef(null);
    const disconnect = useCallback(() => {
        cleanupRef.current?.();
        cleanupRef.current = null;
        setIsStreaming(false);
    }, []);
    const connect = useCallback((config, handlers) => {
        disconnect();
        setIsStreaming(true);
        const wrappedHandlers = {
            onEvent: handlers.onEvent,
            onError: error => {
                setIsStreaming(false);
                cleanupRef.current = null;
                handlers.onError?.(error);
            },
            onComplete: () => {
                setIsStreaming(false);
                cleanupRef.current = null;
                handlers.onComplete?.();
            },
        };
        cleanupRef.current = connectSSE(config, wrappedHandlers);
    }, [disconnect]);
    return { connect, disconnect, isStreaming };
}
//# sourceMappingURL=sse-client.js.map